import DescriptionList from "../Shared/DescriptionList";
import StatusIndicator from "../Shared/StatusIndicator";
import { CURRENCY_CODE_LIST } from "../../config/constants";
import {
  APPOINTMENT_STATUS_NAMES,
  APPOINTMENT_TYPES,
} from "../../config/appointment";
import { getOriginalTimeDisplay } from "../../utility/timezoneUtils";
import { useUserPreferences } from "../../hooks/useUserPreferences";

const ViewAppointment = ({ appointment, clientName }) => {
  const currency = appointment.currency;
  const { is12HourClock } = useUserPreferences();

  let appointmentFields = [];
  const appointmentStatus = (
    <StatusIndicator
      variant="dot"
      colour={appointment?.statusColour}
      label={appointment?.status}
    />
  );
  const appointmentServices = (
    <ul className="space-y-1">
      {appointment?.services?.map((service, index) => (
        <li key={index} className="text-sm">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center">
            <span>
              {service.name}
              {service.quantity > 1 && ` × ${service.quantity}`}
            </span>
            <span className="text-ink-500">
              {CURRENCY_CODE_LIST.find((code) => code.id === currency)?.symbol || "$"}
              {service.price} · {service.duration} min
            </span>
          </div>
        </li>
      ))}
    </ul>
  );

  const startTimeDisplay = (
    <div>
      <div>{appointment?.startTime}</div>
      {getOriginalTimeDisplay(
        appointment?.startTime,
        appointment?.timeZoneId,
        is12HourClock
      ) && (
        <div className="text-sm text-ink-500 mt-1">
          {getOriginalTimeDisplay(
            appointment?.startTime,
            appointment?.timeZoneId,
            is12HourClock
          )}
        </div>
      )}
    </div>
  );

  const endTimeDisplay = (
    <div>
      <div>{appointment?.endTime}</div>
      {getOriginalTimeDisplay(
        appointment?.endTime,
        appointment?.timeZoneId,
        is12HourClock
      ) && (
        <div className="text-sm text-ink-500 mt-1">
          {getOriginalTimeDisplay(
            appointment?.endTime,
            appointment?.timeZoneId,
            is12HourClock
          )}
        </div>
      )}
    </div>
  );

  appointmentFields.push(
    { label: "Client", value: clientName },
    { label: "Status", value: appointmentStatus },
    { label: "Start Time", value: startTimeDisplay },
    { label: "End Time", value: endTimeDisplay },
    { label: "Address", value: appointment?.serviceAddress?.full },
    { label: "Services", value: appointmentServices }
  );

  if (appointment?.type === APPOINTMENT_TYPES.MOBILE)
    appointmentFields.push({
      label: "Travel Fee",
      value: `${
        CURRENCY_CODE_LIST.find((code) => code.id === currency)?.symbol || "$"
      }${appointment.travelFee}`,
    });

  appointmentFields.push({
    label: "Total Price",
    value: `${CURRENCY_CODE_LIST.find((code) => code.id === currency)?.symbol || "$"}${
      appointment?.totalPrice
    } (${currency})`,
  });

  if (appointment?.note) {
    appointmentFields.push({ label: "Notes", value: appointment.note });
  }

  if (
    appointment?.status === APPOINTMENT_STATUS_NAMES.cancelled &&
    appointment?.cancellationReason
  )
    appointmentFields.push({
      label: "Cancellation Reason",
      value: appointment.cancellationReason,
    });

  return <DescriptionList items={appointmentFields} />;
};

export default ViewAppointment;
